"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Time = void 0;
var dayjs_1 = __importDefault(require("dayjs"));
// Dayjs not work in safari 13 #1144
// https://github.com/iamkun/dayjs/issues/1144
var customParseFormat_1 = __importDefault(require("dayjs/plugin/customParseFormat"));
dayjs_1.default.extend(customParseFormat_1.default);
/**
 * 時間を用意に扱うためのクラス
 *
 * @class Time
 */
var Time = /** @class */ (function () {
    // private dateFormat = 'YYYY-MM/DD HH:mm:ss.SSS'
    /**
     * Creates an instance of Time.
     * @param {string} 時間を表現する文字列 format: 2021-10-16T11:48:06+0900 ISO8601 RFC3339 W3CDTF
     * @memberof Time
     */
    function Time(time) {
        // フォーマット
        this.dateFormat = 'YYYYMMDDHHmmssSSS';
        this.myTime = (0, dayjs_1.default)(time, 'YYYY-MM-DDTHH:mm:ss.000ZZ');
        this._originalTime = (0, dayjs_1.default)(time, 'YYYY-MM-DDTHH:mm:ss.000ZZ');
        this.localStartTime = Date.now();
    }
    /**
     * 現在の日時を返します
     *
     * @param {string} [format=this.dateFormat]
     * @return {*}  {string}
     * @memberof Time
     */
    Time.prototype.now = function (format) {
        if (format === void 0) { format = this.dateFormat; }
        // 相対時間算出
        var newTimeMs = Date.now();
        var diffMs = newTimeMs - this.localStartTime;
        // タイムに足す
        return this.myTime.add(diffMs, 'millisecond').format(format);
    };
    /**
     * 初期化時に渡されたタイムを返します
     *
     * @param {string} [format=this.dateFormat]
     * @return {*}  {string}
     * @memberof Time
     */
    Time.prototype.originalTime = function (format) {
        if (format === void 0) { format = this.dateFormat; }
        return this._originalTime.format(format);
    };
    return Time;
}());
exports.Time = Time;
//# sourceMappingURL=Time.js.map